<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.03.01</b> - Долгожданные улучшения качества жизни</p>
    <div class="ml-5 pb-4 text-green-700">
      <div class="font-bold mt-2">Улучшения качества жизни</div>
      <ul class="ml-4 list-disc">
        <li>Добавлена возможность понижать уровень способностей и возвращать очки способностей</li>
        <li>Добавлена возможность понижать уровень атрибутов и возвращать очки атрибутов</li>
        <li>
          Добавлена функция дублирования сборки героя для быстрого копирования существующих сборок
        </li>
        <li>
          Добавлена система проверки версии клиента для уведомления игроков о доступных обновлениях
        </li>
      </ul>

      <div class="font-bold mt-2">Исправления ошибок</div>
      <ul class="ml-4 list-disc">
        <li>
          Исправлены ошибки дублирования и исчезновения предметов при экипировке сумок в слоты
          инвентаря
        </li>
        <li>
          Исправлены вылеты, которые могли происходить при отображении определённых боевых условий
        </li>
      </ul>
    </div>
  </div>
</template>
